var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"containerChart",staticClass:"chart-trend-live container"},[_c('VueApexCharts',{key:_vm.key + _vm.updateGraph,attrs:{"type":"area","options":_vm.chartOptions,"series":_vm.series,"height":_vm.height}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }